import { Grid } from '@freighthub/silhouette-core'
import { BookingParty, LeanQrButton } from 'features/BookingFlow'
import { FC } from 'react'
import { useController, useFormState } from 'react-hook-form'
import { useI18n } from 'utils/localisation'

import { BookingTemplateDetailRow } from './BookingTemplateDetailRow'
import { type BookingTemplateDetailType } from './types/BookingTemplateDetailType'

export const BookingTemplateBookingParty: FC = () => {
  const { translate } = useI18n()

  const { errors } = useFormState<BookingTemplateDetailType>()
  const { field } = useController<BookingTemplateDetailType, 'bookingParty'>({ name: 'bookingParty' })

  return (
    <BookingTemplateDetailRow labelTerm="quote_request-booking_party" error={!!errors.bookingParty}>
      <Grid container spacing={2}>
        <Grid>
          <LeanQrButton
            onClick={() => field.onChange(BookingParty.Buyer)}
            active={field.value === BookingParty.Buyer}
            name={BookingParty.Buyer}
            label={translate('quote_request-booking_party-buyer')}
          />
        </Grid>
        <Grid>
          <LeanQrButton
            onClick={() => field.onChange(BookingParty.Seller)}
            active={field.value === BookingParty.Seller}
            name={BookingParty.Seller}
            label={translate('quote_request-booking_party-seller')}
          />
        </Grid>
      </Grid>
    </BookingTemplateDetailRow>
  )
}
